import { render, staticRenderFns } from "./CarrierProductsEditor.vue?vue&type=template&id=dd23c0be&"
import script from "./CarrierProductsEditor.vue?vue&type=script&lang=js&"
export * from "./CarrierProductsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports